import { Component, Input, OnInit, Output } from '@angular/core';
import { interval } from 'rxjs';

@Component({
    selector: 'pr-progress-cursor',
    templateUrl: './pr-progress-cursor.component.html',
    styleUrls: ['./pr-progress-cursor.component.scss'],
    standalone: false
})
export class PrProgressCursorComponent {
  @Input() steps = ['E', 'D', 'C', 'B', 'A', 'A+'];
  @Input() currentValue = 0;
  @Input() type = 'default';

  calculateCursorPosition(): number {
    if (!this.currentValue) return 0;
    const stepSize = 100 / (this.steps.length - 1);
    return (this.currentValue - 1) * stepSize;
  }
}
